import { render } from "./AdaptiveTextBlockNew.vue?vue&type=template&id=2f6ca681&scoped=true"
import script from "./AdaptiveTextBlockNew.vue?vue&type=script&lang=js"
export * from "./AdaptiveTextBlockNew.vue?vue&type=script&lang=js"

import "./AdaptiveTextBlockNew.vue?vue&type=style&index=0&id=2f6ca681&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6ca681"]])

export default __exports__